import { createAction, props } from '@ngrx/store';
import { RideMonitoringState } from './ride-monitoring.reducer';

import { ApplicationException, HttpException } from '@uzurv/core';
import {
  CustomerServiceNote,
  CustomerServiceNoteDetail,
  Itinerary,
  OperationsAlertType,
  RideMonitoringAlert,
  RideMonitoringAlertList,
  TransitProgram
} from '@uzurv/clara';
import { ReservationListItemVm } from '../../components/reservation';
import { SafeUrl } from '@angular/platform-browser';

export const RestoreState = createAction('[Ride Monitoring] Restore state', props<{ state: RideMonitoringState }>());

export const FetchOperationsAlertTypes = createAction('[Ride Monitoring] Fetch operations alert types');

export const FetchOperationsAlertTypesSuccess = createAction(
  '[Ride Monitoring] Fetch operations alert types success',
  props<{ operationsAlertTypes: Array<OperationsAlertType> }>()
);

export const FetchOperationsAlertTypesFail = createAction(
  '[Ride Monitoring] Fetch operations alert types fail',
  props<{ error: HttpException }>()
);

export const FetchTransitPrograms = createAction('[Ride Monitoring] Fetch transit programs');

export const FetchTransitProgramsSuccess = createAction(
  '[Ride Monitoring] Fetch transit programs success',
  props<{ transitPrograms: Array<TransitProgram> }>()
);

export const FetchTransitProgramsFail = createAction('[Ride Monitoring] Fetch transit programs fail', props<{ error: HttpException }>());

export const SelectRideStatuses = createAction('[Ride Monitoring] Select ride statuses', props<{ rideStatusNames: Array<string> }>());

export const SelectTransitProgramIds = createAction(
  '[Ride Monitoring] Select transit program ids',
  props<{ transitProgramIds: Array<number> }>()
);

export const SelectOperationsAlertTypeIds = createAction(
  '[Ride Monitoring] Select operation alert type ids',
  props<{ operationAlertTypeIds: Array<number> }>()
);

export const initializeFilters = createAction(
  '[Ride Monitoring] Initialize filters',
  props<{ rideStatusNames: Array<string>; transitProgramIds: Array<number>; selectedOperationsAlertTypeIds: Array<number> }>()
);

export const ClearFilters = createAction('[Ride Monitoring] Clear filters');

export const RefreshAlerts = createAction('[Ride Monitoring] Refresh alerts');

export const RefreshAlertsSuccess = createAction('[Ride Monitoring] Refresh alerts success', props<{ alerts: RideMonitoringAlertList }>());

export const FetchNextAlertsPage = createAction('[Ride Monitoring] Fetch next alerts page');

export const FetchNextAlertsPageSuccess = createAction(
  '[Ride Monitoring] Fetch next alerts page success',
  props<{ alerts: RideMonitoringAlertList }>()
);

export const FetchAlertsFail = createAction('[Ride Monitoring] Fetch alerts fail', props<{ error: HttpException }>());

export const SetSelectedAlert = createAction('[Ride Monitoring] Set selected alert', props<{ alert: RideMonitoringAlert }>());

export const SetSelectedAlertSuccess = createAction(
  '[Ride Monitoring] Set selected alert success',
  props<{ alert: RideMonitoringAlert; reservationListItemVm: ReservationListItemVm }>()
);

export const SetSelectedAlertFail = createAction('[Ride Monitoring] Set selected alert fail', props<{ error: HttpException }>());

export const RemoveSelectedAlert = createAction('[Ride Monitoring] Remove selected alert');

export const StartPollingAlerts = createAction('[Ride Monitoring] Start polling alerts');

export const StopPollingAlerts = createAction('[Ride Monitoring] Stop polling alerts');

export const GetDriverProfilePictureSuccess = createAction(
  '[Ride Monitoring] Get driver profile picture success',
  props<{ safeUrl: SafeUrl }>()
);

export const GetDriverProfilePictureFail = createAction(
  '[Ride Monitoring] Get driver profile picture fail',
  props<{ error: HttpException }>()
);

export const CancelTrip = createAction('[Ride Monitoring] Cancel trip');

export const CancelTripSuccess = createAction('[Ride Monitoring] Cancel trip success', props<{ recoveryItinerary?: Itinerary }>());

export const CancelTripFail = createAction('[Ride Monitoring] Cancel trip fail', props<{ error: ApplicationException }>());

export const CreateRecovery = createAction('[Ride Monitoring] Create recovery');

export const SendRideToLyft = createAction('[Ride Monitoring] Send ride to Lyft');

export const DispatchToLyft = createAction('[Ride Monitoring] Dispatch to lyft');

export const DispatchToLyftSuccess = createAction('[Ride Monitoring] Dispatch to lyft success');

export const DispatchToLyftFail = createAction('[Ride Monitoring] Dispatch to lyft fail', props<{ error: HttpException }>());

export const EditIncentiveAmount = createAction('[Ride Monitoring] Edit incentive amount', props<{ incentive: number }>());

export const EditIncentiveAmountSuccess = createAction('[Ride Monitoring] Edit incentive amount success', props<{ incentive: number }>());

export const EditIncentiveAmountFail = createAction('[Ride Monitoring] Edit incentive amount fail', props<{ error: HttpException }>());

export const AddNote = createAction('[Ride Monitoring] Add note', props<{ customerServiceNote: CustomerServiceNote }>());

export const AddNoteSuccess = createAction('[Ride Monitoring] Add note success', props<{ customerServiceNotes: CustomerServiceNote }>());

export const AddNoteFail = createAction('[Ride Monitoring] Add note fail', props<{ error: HttpException }>());

export const GetNotes = createAction('[Ride Monitoring] Get notes');

export const GetNotesSuccess = createAction('[Ride Monitoring] Get notes success', props<{ notes: Array<CustomerServiceNoteDetail> }>());

export const GetNotesFail = createAction('[Ride Monitoring] Get notes fail', props<{ error: HttpException }>());

export const OpenRideMonitoringAlertDialog = createAction(
  '[Ride Monitoring] Open ride monitoring alert dialog',
  props<{ alert: RideMonitoringAlert }>()
);

export const ResolveRideMonitoringAlert = createAction(
  '[Ride Monitoring] Resolve ride monitoring alert',
  props<{ alert: RideMonitoringAlert; customerServiceNote: CustomerServiceNote }>()
);

export const ResolveRideMonitoringAlertSuccess = createAction(
  '[Ride Monitoring] Resolve ride monitoring alert success',
  props<{ alert: RideMonitoringAlert }>
);

export const ResolveRideMonitoringAlertFail = createAction(
  '[Ride Monitoring] Resolve ride monitoring alert fail',
  props<{ error: HttpException }>()
);

export const SelectProvider = createAction('[Ride Monitoring] Select provider');

export const SelectDriver = createAction('[Ride Monitoring] Select driver');
